import { useState, useEffect } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Grid, Typography, Button, IconButton, Avatar, Alert, Backdrop, CircularProgress, Tooltip, Dialog, DialogTitle, Select, MenuItem, Divider, DialogContent, Box, Stack } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
// project imports
import ShirtImage from 'src/assets/images/Clothes/shirt.jpg';
import ShirtImageBeko from 'src/assets/images/Clothes/shirtBekoBayi.jpg';
import ShirtImageArcelik from 'src/assets/images/Clothes/shirtArcelikBayi.jpg';
import PantsImage from 'src/assets/images/Clothes/pants.jpg';
import LongShirtImageBeko from 'src/assets/images/Clothes/longshirtBekoBayi.jpg';
import LongShirtImageArcelik from 'src/assets/images/Clothes/longshirtArcelikBayi.jpg';

import HirkaBeko from 'src/assets/images/Clothes/HirkaBeko.jpg';
import HirkaArcelik from 'src/assets/images/Clothes/HirkaArcelik.jpg';

import YelekBeko from 'src/assets/images/Clothes/YelekBeko.jpg';
import YelekArcelik from 'src/assets/images/Clothes/YelekArcelik.jpg';

import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import CloseIcon from '@mui/icons-material/Close';

import ShoeImage from 'src/assets/images/Clothes/shoe.jpg';
import { Delete } from '@mui/icons-material';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';


// ==============================|| PROFILE 1 - MY ACCOUNT ||============================== //

const styles = {
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }),
  container: (theme) => ({
    padding: theme.spacing(2),
    backgroundColor: "#f5f5f5", // Arka plan rengi
    marginBottom: theme.spacing(1),
    borderRadius: theme.spacing(1), // Kenar yuvarlatma
  }),
  zebraStripe: {
    backgroundColor: "#ffffff", // Zebra çizgilerinin rengi
    "&:nth-child(even)": {
      backgroundColor: "#f9f9f9", // Çift sıralar için farklı bir renk
    },
  },
  text: {
    fontWeight: "bold",
  },
};

const Clothes = ({ EmployeeNr }) => {
  const theme = useTheme();
  const [isAvatarEnlarged, setIsAvatarEnlarged] = useState({});

  const [clothingTypes, setclothingTypes] = useState([]);
  const [sizesByNumber, setsizesByNumber] = useState([]);
  const [sizesByText, setsizesByText] = useState([]);

  const [historyData, setHistoryData] = useState([]);
  const [historyClothes, setHistoryClothes] = useState(false);
  const [employee, setEmployee] = useState(null);
  const [open, setOpen] = useState(false);


  const isMale = employee?.Sex == "Erkek";
  const imageSrc = isMale ? "/images/erkek_beden_info.svg" : "/images/kadin_beden_info.svg";
  const imageAlt = isMale ? "Erkek Beden Tablosu" : "Kadın Beden Tablosu";

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  }


  if (EmployeeNr === 0) {
    return (
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            sm: 12,
            md: 12
          }}>
          <Alert variant="outlined" severity="error" sx={{ borderColor: theme.palette.warning.dark }}>
            <Typography variant='h5' style={{ color: 'red' }}>Önce Kayıt İşlemini Tamamlamanız Gerekli!....
            </Typography>
          </Alert>
          {/*  */}
        </Grid>
      </Grid>
    );
  }

  useEffect(() => {
    // Fetch the employee information
    Promise.all([
      axios.get(`GetWorkerInfo/${EmployeeNr}`)
    ]).then(([infoResponse]) => {
      setLoading(false);
      const employeeInfo = infoResponse.data[0] || {};
      setEmployee(employeeInfo);
    });
  }, [EmployeeNr]);

  var ServisKiyafet = [
    { id: 1, type: 'Üst Giyim', image: ShirtImage },
    { id: 2, type: 'Pantolon', image: PantsImage },
    { id: 4, type: 'Ayakkabı', image: ShoeImage },
  ];
  var ServisSizeNumber = [
    { id: 1, size: '36' },
    { id: 2, size: '38' },
    { id: 3, size: '40' },
    { id: 4, size: '42' },
    { id: 5, size: '44' },
    { id: 6, size: '46' },
    { id: 7, size: '48' },
    { id: 8, size: '50' },
    { id: 9, size: '52' },
    { id: 10, size: '54' },
    { id: 11, size: '56' },
    { id: 12, size: '58' },
    { id: 13, size: '60' },
    { id: 14, size: '62' },
    { id: 15, size: '64' },
    { id: 16, size: '66' },
    { id: 17, size: '68' },
  ];

  var ServisShoeSizeNumber = [
    { id: 1, size: '35' },
    { id: 2, size: '36' },
    { id: 3, size: '37' },
    { id: 4, size: '38' },
    { id: 5, size: '39' },
    { id: 6, size: '40' },
    { id: 7, size: '41' },
    { id: 8, size: '42' },
    { id: 9, size: '43' },
    { id: 10, size: '44' },
    { id: 11, size: '45' },
    { id: 12, size: '46' },
    { id: 13, size: '47' },
    { id: 14, size: '48' },
    { id: 15, size: '49' },
    { id: 16, size: '50' },
  ];


  var ServisSizeText = [
    { id: 10, size: 'XS' },
    { id: 1, size: 'S' },
    { id: 2, size: 'M' },
    { id: 3, size: 'L' },
    { id: 4, size: 'XL' },
    { id: 5, size: 'XXL' },
    { id: 6, size: '3XL' },
    { id: 7, size: '4XL' },
    { id: 8, size: '5XL' },
    { id: 9, size: '6XL' }
  ];


  var BekoBayiKiyafet = [
    { id: 9, type: 'Kısa Kol Tişört', image: ShirtImageBeko },
    { id: 10, type: 'Uzun Kol Tişört', image: LongShirtImageBeko },
    { id: 11, type: 'Hırka', image: HirkaBeko },
    { id: 12, type: 'Yelek', image: YelekBeko }
  ];
  var BekoSizeText = [
    { id: 1, size: 'S' },
    { id: 2, size: 'M' },
    { id: 3, size: 'L' },
    { id: 4, size: 'XL' },
    { id: 5, size: 'XXL' },
    { id: 6, size: '3XL' },
    { id: 10, size: 'XS' }
  ];


  var ArcelikBayiKiyafet = [
    { id: 9, type: 'Kısa Kol Tişört', image: ShirtImageArcelik },
    { id: 10, type: 'Uzun Kol Tişört', image: LongShirtImageArcelik },
    { id: 11, type: 'Hırka', image: HirkaArcelik },
    { id: 12, type: 'Yelek', image: YelekArcelik }
  ];
  var ArcelikSizeText = [
    { id: 1, size: 'S' },
    { id: 2, size: 'M' },
    { id: 3, size: 'L' },
    { id: 4, size: 'XL' },
    { id: 5, size: 'XXL' },
    { id: 6, size: '3XL' },
    { id: 10, size: 'XS' }
  ];



  const [sizes, setSizes] = useState([]);
  const [newSizeType, setNewSizeType] = useState('');
  const [newSize, setNewSize] = useState('');
  const [SizeDetailData, setSizeDetailData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [Brand, setBrand] = useState('0');
  const SessionUser = getUser();
  const [yetki, setYetki] = useState([]);


  const handleAddSize = () => {
    var KıyafetTip = clothingTypes.filter(x => x.id === newSizeType)[0].type;
    var KıyafetSize;
    if (newSizeType === 4) {
      KıyafetSize = ServisShoeSizeNumber?.filter(x => x?.id === newSize)[0]?.size;
    }
    else if (newSizeType === 2) {
      KıyafetSize = sizesByNumber?.filter(x => x?.id === newSize)[0]?.size;
    }
    else {
      KıyafetSize = sizesByText?.filter(x => x?.id === newSize)[0]?.size;
    }
    if (KıyafetSize === undefined) {
      return;
    }
    // setSizes([...sizes, newSizeObj]);
    setLoading(true);

    axios.get(`SetEmplyeeClothes/${EmployeeNr}/${KıyafetTip}/${KıyafetSize}/0/1`).then((response) => {
      setNewSizeType('');
      setNewSize('');
      getEmployeeClothes();
      getEmployeeHistoryClothes();
    });
    setLoading(false);

  };

  const handleDeleteSize = (id) => {

    confirmAlert({
      message: "Kıyafet silinecektir!... Devam etmek istediginizden emin misiniz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleDeleteSizeParam(id)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  };

  const handleDeleteSizeParam = (id) => {
    setLoading(true);
    axios.get(`SetEmplyeeClothes/${EmployeeNr}/0/0/${id}/0`).then((response) => {
      getEmployeeClothes();
      getEmployeeHistoryClothes();
      setLoading(false);
    });
  };


  const setNewSizeTypeChange = (SizeType) => {
    setNewSizeType(SizeType);
    if (SizeType === 4) {
      setSizeDetailData(ServisShoeSizeNumber);
    }
    else if (SizeType === 2) {
      setSizeDetailData(sizesByNumber);
    } else {
      setSizeDetailData(sizesByText);
    }
  }
  const getEmployeeYetki = () => {
    setLoading(true);
    axios.get(`GetEmployeeYetki`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setYetki(response.data);
        } else {
          setYetki([]);
        }
        setLoading(false);
      });
  }



  useEffect(() => {
    getEmployeeClothes();
    getEmployeeHistoryClothes();
    getEmployeeYetki();
  }, []);


  const getEmployeeHistoryClothes = () => {
    setLoading(true);
    axios.get(`GetEmployeeHistoryClothes/${EmployeeNr}`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setHistoryData(response.data)
        } else {
          setSizes([]);
        }
        setLoading(false);
      });
  }

  const getEmployeeClothes = () => {
    setLoading(true);
    axios.get(`GetEmplyeeClothes/${EmployeeNr}`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setSizes(response.data.filter(x => x.id > 0));
          var BrandControl = response.data.filter(x => x.id === -1)[0]?.size;
          setBrand(response.data.filter(x => x.id === -1)[0]?.size);
          if (BrandControl === '0') {
            setclothingTypes(ServisKiyafet);
            setsizesByNumber(ServisSizeNumber);
            setsizesByText(ServisSizeText);
          }
          if (BrandControl === '4') {
            setclothingTypes(BekoBayiKiyafet);
            setsizesByNumber(ServisSizeNumber);
            setsizesByText(BekoSizeText);
          }
          if (BrandControl === '3') {
            setclothingTypes(ArcelikBayiKiyafet);
            setsizesByNumber(ServisSizeNumber);
            setsizesByText(ArcelikSizeText);
          }
        } else {
          setSizes([]);
        }
        setLoading(false);
      });

  }



  const handleAvatarMouseEnter = (avatarId) => {
    setIsAvatarEnlarged((prevState) => ({ ...prevState, [avatarId]: true }));
  };

  const handleAvatarMouseLeave = (avatarId) => {
    setIsAvatarEnlarged((prevState) => ({ ...prevState, [avatarId]: false }));
  };


  return (
    <div>
      {
        loading ?
          <Backdrop sx={styles.backdrop} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          : <div></div>
      }
      <Grid container spacing={4}>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid>
              <Typography variant="h5">Kıyafet</Typography>
            </Grid>
            <Grid>
              <Tooltip title="Tarihçe">
                <IconButton size="large"
                  sx={{
                    '&:hover': { backgroundColor: '#FF9800 !important', },
                  }}
                  onClick={() => {
                    setHistoryClothes(true);
                  }}
                >
                  <TroubleshootIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
          <Divider sx={{ mb: 2 }} />
          {sizes.length > 0 ? (
            <Stack divider={<Divider />} spacing={1.5}>
              {sizes.map((size) => (
                <Grid container alignItems="center" key={size.id}>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 3,
                      md: 2
                    }}>
                    <Avatar
                      alt={size.type}
                      src={clothingTypes?.find((type) => type?.type === size?.type)?.image}
                      style={{
                        transform: isAvatarEnlarged[size.id] ? 'scale(5)' : 'scale(1)',
                        transformOrigin: 'left',
                        zIndex: isAvatarEnlarged[size.id] ? 999 : 'auto',
                      }}
                      onMouseEnter={() => handleAvatarMouseEnter(size.id)}
                      onMouseLeave={() => handleAvatarMouseLeave(size.id)}
                    />
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 3,
                      md: 2
                    }}>
                    <Typography>{size.type}</Typography>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 3,
                      md: 2
                    }}>
                    <Typography>{size.size}</Typography>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 3,
                      md: 2
                    }}>
                    <Typography>{size.Kullanici}</Typography>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 3,
                      md: 2
                    }}>
                    <Typography>{size.Date}</Typography>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 12,
                      md: 2
                    }}>
                    <IconButton onClick={() => handleDeleteSize(size.id)}
                      disabled={yetki.find(item => item.ALAN_ADI === 'dsDeleteSize')?.DISABLE_ALAN}
                    >
                      <Delete style={{ color: 'red' }} />
                    </IconButton>
                  </Grid>
                </Grid>
              ))}
            </Stack>
          ) : (
            <Typography color="text.secondary">Kayıtlı kıyafet bilgisi bulunmamaktadır.</Typography>
          )}
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 6
          }}
          sx={{
            borderLeft: { md: '1px solid' },
            borderColor: 'divider',
            pl: { md: 4 }
          }}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid>
              <Typography variant="h5">Yeni Kıyafet Ekle</Typography>
            </Grid>
            <Grid>
              <Button variant="outlined" onClick={handleClickOpen}>
                BEDEN TABLOSU
              </Button>
            </Grid>
          </Grid>
          <Divider sx={{ mb: 2 }} />
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="lg"
              fullWidth
            >
              <DialogTitle id="alert-dialog-title" >
                <Box display="flex" alignItems="center" justifyContent="space-between" >
                  <Typography variant="h6">
                    {imageAlt}
                  </Typography>
                  <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                      position: 'absolute',
                      right: '1',
                      top: '8',
                      color: (theme) => theme.palette.grey[500]
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
              </DialogTitle>
              <DialogContent dividers>
                <img
                  src={imageSrc}
                  alt={imageAlt}
                  style={{
                    width: '100%',
                    maxHeight: '80vh',
                    objectFit: 'contain',
                    display: 'block',
                    margin: '0 auto',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    // marginTop: '10px'
                  }}
                />
              </DialogContent>
            </Dialog>
            <Grid container spacing={2}>
              <Grid
                size={{
                  xs: 12,
                  sm: 12,
                  md: 6
                }}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel htmlFor="outlined-age-native-simple">Kıyafet Tipi</InputLabel>
                  <Select
                    label="Kıyafet Tipi"
                    value={newSizeType}
                    onChange={(e) => setNewSizeTypeChange(e.target.value)}
                    disabled={yetki.find(item => item.ALAN_ADI === 'dsNewSizeType')?.DISABLE_ALAN}
                    fullWidth
                    size="small"
                    inputProps={{
                      name: 'age',
                      id: 'outlined-age-native-simple',
                    }}
                  >
                    {clothingTypes?.map((type) => (
                      <MenuItem key={type.id} value={type.id}>
                        {type.type}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 12,
                  md: 6
                }}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel htmlFor="outlined-age-native-simple">Beden</InputLabel>
                  <Select
                    label="Beden"
                    value={newSize}
                    onChange={(e) => setNewSize(e.target.value)}
                    disabled={yetki.find(item => item.ALAN_ADI === 'dsNewSize')?.DISABLE_ALAN}
                    fullWidth
                    size="small"
                    inputProps={{
                      name: 'age',
                      id: 'outlined-age-native-simple',
                    }}
                  >
                    {SizeDetailData?.map((size) => (
                      <MenuItem key={size.id} value={size.id}>
                        {size.size}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                style={{ textAlign: "right" }}
                size={{
                  xs: 12,
                  sm: 12,
                  md: 12
                }}>
                <Button variant="contained"
                  color="secondary"
                  style={{ textTransform: 'none' }}
                  startIcon={<CheckroomIcon />}
                  disabled={yetki.find(item => item.ALAN_ADI === 'dsAddSize')?.DISABLE_ALAN}
                  onClick={handleAddSize}>
                  Ekle
                </Button>
              </Grid>
            </Grid>
        </Grid>
        <Dialog
          open={historyClothes}
          fullWidth
          maxWidth="md"
          onClose={() => setHistoryClothes(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
            Kıyafet Tarihçe
            <IconButton
              onClick={() => setHistoryClothes(false)}
              aria-label="close"
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500]
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <Divider />
          <DialogContent sx={{ maxHeight: 400, overflowY: 'auto' }}>
            {historyData.map((item) => (
              <Box key={item.id} sx={[styles.container, styles.zebraStripe]}>
                <Grid container alignItems="center">
                  <Grid
                    size={{
                      xs: 12,
                      sm: 3,
                      md: 3
                    }}>
                    <Typography sx={styles.text}>{item.ELEMAN_NO}</Typography>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 3,
                      md: 3
                    }}>
                    <Typography sx={styles.text}>{item.ACIKLAMA}</Typography>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 3,
                      md: 3
                    }}>
                    <Typography sx={styles.text}>{item.Kullanici}</Typography>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 3,
                      md: 3
                    }}>
                    <Typography sx={styles.text}>{item.Date}</Typography>
                  </Grid>
                </Grid>
              </Box>
            ))}
          </DialogContent>
        </Dialog>
      </Grid>
    </div >
  );
};

export default Clothes;
